module.exports = __webpack_public_path__ + "static/img/fish10.8bdf945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish10.png
// module id = Q8rD
// module chunks = 0